import script from "./StatisticDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./StatisticDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./StatisticDetailPage.vue?vue&type=style&index=0&id=0e82de72&scoped=true&lang=css"

import exportComponent from "/home/guenter/Entwicklung/technic-gmbh/transparent-charge-app/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e82de72"]])

export default __exports__